<template>
  <BaseCard>
    <template v-slot:header>
      <BaseCardHeading>Borrower Experience</BaseCardHeading>
      <BaseButton
        :to="{ name: 'experience' }"
        primary
        small>
        Edit
      </BaseButton>
    </template>

    <dl class="row mb-0">
      <dt class="col-sm-6">Status</dt>
      <dd class="col-sm-6">Incomplete</dd>
      <dt class="col-sm-6">Projects Completed</dt>
      <dd class="col-sm-6">{{ total }}</dd>
      <dt class="col-sm-6">Value of Projects</dt>
      <dd class="col-sm-6">{{ gdv }}</dd>
    </dl>
  </BaseCard>
</template>

<script>
import { mapState } from 'vuex'
import { Formatting } from '@/mixins'

import BaseButton from './BaseButton.vue'
import BaseCard from './BaseCard.vue'
import BaseCardHeading from './BaseCardHeading.vue'

export default {
  async created () {
    await this.$store.dispatch('core/experiences/list', {
      query: {
        user: this.$auth.user._id
      }
    })
  },

  name: 'ExperienceProgress',

  components: {
    BaseButton,
    BaseCard,
    BaseCardHeading
  },

  mixins: [Formatting],

  computed: {
    gdv () {
      return this.toCurrency(this.$_.sumBy(this.experiences, 'financials.gdv'))
    },

    total () {
      return this.experiences.length
    },

    ...mapState({
      experiences: store => store.core.experiences.rows
    })
  }
}
</script>
